<div class="section-details-with-icon">
  <div class="section-details">
    <% if (addresses.length > 1) { %>
      <div class="select-location">
        <a role="button" tabindex="0" class="select-location-trigger">
          <span class="select-location-icon">&nbsp;</span>
          <span class="select-location-name"><%= selectedAddress.short_name || selectedAddress.name || selectedAddress.first_line %></span> <span class="select-location-caret"></span>
        </a>
        <div class="select-location-dropdown">
          <div class="select-location-dropdown-inner">
            <% _.each(addresses, function(address){ %>
              <label class="appointment-location" data-appointment-booking-provider-widget-behaviour="select-address" data-address-id=<%= address.id %>>
                <input class="appointment-location-radio" type="radio" name="appointment-location" <% if (address.id == selectedAddress.id) { %> checked <% } %> value="<%= address.id %>">
                <div class="select-indicator"></div>
                <div class="appointment-location-details">
                  <%= Sparkle.Client.jstTemplate('appointment_booking/provider_widget/templates/_address')({ address: address }) %>
                </div>
              </label>
            <% }) %>
          </div>
        </div>
      </div>
    <% } %>
  </div>
</div>
